<template>
  <div class="GigsList container">
    <div v-if = "Object.keys(gigsByMonth).length > 0">
      <div
        v-for="(gigsThisMonth, month) in gigsByMonth"
        :key="month"
        class="GigsList__month-group"
      >
        <div class="GigsList__month-group-month">
          {{ months[(new Date(month)).getMonth()] }}
        </div>

        <div v-if="gigsThisMonth">
          <GigComponent
            v-for="gig in gigsThisMonth"
            :key="gig.id"
            :gig="gig"
          />
        </div>

        <div v-else>
          <div class="Gig Gig--panel Gig--none">
            <div class="Gig__title">
              No gigs found for {{ months[(new Date(month)).getMonth()] }} {{ (new Date(month)).getFullYear() }}
            </div>

            <div class="Gig__venue">
              <a
                href="#"
                @click.prevent="handleMonthFilterResetClick"
              >
                Reset filters to see all upcoming gigs
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div v-else >
      <div class="Gig Gig--panel Gig--none Gig--none--all">
        <div class="Gig__title">
          No recent gigs found
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import GigComponent from '../gig/GigComponent.vue';

export default {
  components: {
    GigComponent,
  },
  props: {
    gigsByMonth: {
      default: () => {},
      type: Object,
    },
    months: {
      default: () => ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
      type: Array,
    },
  },
  methods: {
    handleMonthFilterResetClick() {
      this.$parent.setFilterMonth('');
    },
  },
};
</script>
